import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import {
  clearPreguntasConfirmacionPlantelError,
  resetPreguntasConfirmacionPlantel,
  setPage,
} from "../../../store/reducers/preguntasConfirmacion/question-confirmation-page/Preguntasconfirmacionplantel.reducer";
import Loader from "../../UI/Loader";
import Alert from "../../UI/Alert";
import Pagination from "../../UI/Pagination";
import EmptyState from "../../UI/EmptyState";
import PreguntasConfirmacionPlantelTable from "./Preguntasconfirmacionplanteltable";
import QuestionConfirmationHeaderPlantel from "./QuestionConfirmationHeaderPlantel";
import PreguntaConfirmacionViewModalPlantel from "./Preguntaconfirmacionviewmodalplantel";
import PreguntaConfirmacionFormModalPlantel from "./Preguntaconfirmacionformmodalplantel";
import ConfirmToggleModalPlantel from "./Confirmtogglemodalplantel";
import { getPreguntasConfirmacionPlantelThunk } from "../../../store/reducers/preguntasConfirmacion/question-confirmation-page/Preguntasconfirmacionplantel.thunks";

const QuestionsConfirmationListLayerPlantel = () => {
  const dispatch = useDispatch();
  const { plantelId } = useParams();

  const { list, loading, error, page, pageSize, search, count } = useSelector(
    (state) => state.preguntasConfirmacionPlantel,
  );

  // Fetch cada vez que cambien plantelId, page o search
  useEffect(() => {
    if (!plantelId) return;
    dispatch(getPreguntasConfirmacionPlantelThunk({ plantelId, page, search }));
  }, [dispatch, plantelId, page, search]);

  // Limpiar estado al desmontar para no mezclar datos entre planteles
  useEffect(() => {
    return () => {
      dispatch(resetPreguntasConfirmacionPlantel());
    };
  }, [dispatch]);

  const handlePageChange = (newPage) => {
    dispatch(setPage(newPage));
  };

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <QuestionConfirmationHeaderPlantel />

        {/* ERROR */}
        {error && (
          <Alert
            message={error}
            variant="error"
            onClose={() => dispatch(clearPreguntasConfirmacionPlantelError())}
          />
        )}

        {/* LOADING */}
        {loading ? (
          <Loader center text="Cargando preguntas..." delay={200} />
        ) : (
          <>
            {/* INFO DE BÚSQUEDA */}
            {search && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">
                  {count > 0 ? (
                    <>
                      Se {count === 1 ? "encontró" : "encontraron"}{" "}
                      <strong className="text-primary">{count}</strong>{" "}
                      {count === 1 ? "resultado" : "resultados"} para "{search}"
                    </>
                  ) : (
                    <>No se encontraron resultados para "{search}"</>
                  )}
                </span>
              </div>
            )}

            {/* EMPTY / TABLE */}
            {list.length === 0 ? (
              <EmptyState
                icon={
                  search
                    ? "mdi:magnify-remove-outline"
                    : "mdi:help-circle-outline"
                }
                title={
                  search
                    ? "No se encontraron preguntas"
                    : "No hay preguntas registradas"
                }
                description={
                  search
                    ? "Intenta con otra búsqueda"
                    : "No hay preguntas disponibles para este plantel"
                }
              />
            ) : (
              <>
                <PreguntasConfirmacionPlantelTable
                  preguntas={list}
                  search={search}
                />

                <Pagination
                  page={page}
                  count={count}
                  pageSize={pageSize}
                  onPageChange={handlePageChange}
                />
              </>
            )}
          </>
        )}
      </div>

      {/* MODALES */}
      <PreguntaConfirmacionViewModalPlantel />
      <PreguntaConfirmacionFormModalPlantel />
      <ConfirmToggleModalPlantel />
    </div>
  );
};

export default QuestionsConfirmationListLayerPlantel;
